var exports = {
  "kL": "xfd349460--22db7c--container",
  "Sl": "xfd349460--22db7c--image",
  "DD": "xfd349460--22db7c--title",
  "UE": "xfd349460--22db7c--arrow",
  "Y9": "xfd349460--22db7c--arrow-hovered",
  "KI": "xfd349460--22db7c--icon_container",
};

module.exports = exports;
